﻿(function () {
    "use strict";

    angular.module("app").controller("ConsultationsController", ConsultationsController);

    ConsultationsController.$inject = [];

    function ConsultationsController() {
        var vm = this
    }
})();